export const calculateMarcoFijo = (width, height) => {
  const verticalElements = {
    'Marco': Math.floor(height + 5),
    'Refuerzo Marco': Math.floor(height - 126),
    'Junquillo': Math.floor(height - 80),
  };

  const horizontalElements = {
    'Marco': Math.floor(width + 5),
    'Refuerzo Marco': Math.floor(width - 126),
    'Junquillo': Math.floor(width - 80),
  };

  // Calcular barras necesarias (considerando que cada elemento necesita 2 piezas)
  const barrasNecesarias = {};
  const largoBarra = 6000; // mm

  for (const [perfil, largo] of Object.entries(verticalElements)) {
    const cantidadPiezas = 2;
    const piezasVerticales = Array(cantidadPiezas).fill(largo);
    
    barrasNecesarias[perfil] = {
      cantidadBarras: Math.ceil((largo * cantidadPiezas) / largoBarra),
      desperdicioMm: (Math.ceil((largo * cantidadPiezas) / largoBarra) * largoBarra) - (largo * cantidadPiezas),
      piezasVerticales,
      piezasHorizontales: [],
      largoTotal: largo * cantidadPiezas
    };
  }

  for (const [perfil, largo] of Object.entries(horizontalElements)) {
    const cantidadPiezas = 2;
    const piezasHorizontales = Array(cantidadPiezas).fill(largo);
    
    if (!barrasNecesarias[perfil]) {
      barrasNecesarias[perfil] = {
        cantidadBarras: Math.ceil((largo * cantidadPiezas) / largoBarra),
        desperdicioMm: (Math.ceil((largo * cantidadPiezas) / largoBarra) * largoBarra) - (largo * cantidadPiezas),
        piezasVerticales: [],
        piezasHorizontales,
        largoTotal: largo * cantidadPiezas
      };
    } else {
      const largoTotalCombinado = (largo * cantidadPiezas) + barrasNecesarias[perfil].largoTotal;
      barrasNecesarias[perfil] = {
        ...barrasNecesarias[perfil],
        cantidadBarras: Math.ceil(largoTotalCombinado / largoBarra),
        desperdicioMm: (Math.ceil(largoTotalCombinado / largoBarra) * largoBarra) - largoTotalCombinado,
        piezasHorizontales,
        largoTotal: largoTotalCombinado
      };
    }
  }

  return {
    vertical: verticalElements,
    horizontal: horizontalElements,
    barrasNecesarias,
    type: 'Marco Fijo',
    photo: "/fotos/marco-fijo.jpg" ,
  };
};

export const calculateVidriosMarcoFijo = (height, width) => {
  const vidrioHeight = Math.floor(height - 88);
  const vidrioWidth = Math.floor(width - 88);

  return { 
    vertical: Math.max(0, vidrioHeight), 
    horizontal: Math.max(0, vidrioWidth) 
  };
};
